export const get_Data ='get_Data';
export const get_quantity ='get_quantity';
export const set_loading = 'set_loading';
export const set_cartItems = 'set_cartItems';
export const set_BucketDisplay = 'set_BucketDisplay';
export const set_CheckoutDisplay = 'set_CheckoutDisplay';
export const set_IsSubmitted = 'set_IsSubmitted '